export default function () {
  let prevClientHeight
  const customVar = '--vh'
  function handleResize() {
    const { clientHeight } = document.documentElement
    if (clientHeight === prevClientHeight) return
    requestAnimationFrame(() => {
      document.documentElement.style.setProperty(customVar, `${clientHeight * 0.01}px`)
      prevClientHeight = clientHeight
    })
  }
  window.addEventListener('resize', handleResize)
  handleResize()
}
